import { render, staticRenderFns } from "./OffersContainer.vue?vue&type=template&id=a81f6198&scoped=true&"
import script from "./OffersContainer.vue?vue&type=script&lang=js&"
export * from "./OffersContainer.vue?vue&type=script&lang=js&"
import style0 from "./OffersContainer.vue?vue&type=style&index=0&id=a81f6198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81f6198",
  null
  
)

export default component.exports